import { render, staticRenderFns } from "./LiveRoomCallBack.vue?vue&type=template&id=4d4034ea&scoped=true&"
import script from "./LiveRoomCallBack.vue?vue&type=script&lang=js&"
export * from "./LiveRoomCallBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4034ea",
  null
  
)

export default component.exports